import { Controller } from "@hotwired/stimulus"
import { createAlert } from "../scripts/createAlert"

export default class extends Controller {
  static targets = [ 'email', 'phone', 'form' ]

  connect() {
    // console.log("Hello, from Feature Story Contact controller", this.element)
    // console.log(this.emailTarget)
    // console.log(this.phoneTarget)
    // this.determineRequiredStatus();
  }

  determineRequiredStatus() {
    if (this.emailTarget.value === "" && this.phoneTarget.value === "") {
      this.emailTarget.classList.add('is-invalid');
      this.phoneTarget.classList.add('is-invalid');
      return false;
    }

    return true;
  }

  attemptSubmit(event) {
    event.preventDefault();
    const valid = this.determineRequiredStatus();
    if (valid) {
      this.formTarget.submit();
    }
    else {
      createAlert('danger', 'Please enter an email or phone number');
    }
  }
}

